export function getActiveFilters(filters, filterGroups) {
  const items = [];

  filterGroups.forEach((group) => {
    const groupValues = filters[group.key];
    if (!groupValues) {
      return;
    }

    group.filters.forEach(({ key, label, options }) => {
      const value = groupValues[key];
      if (!value) {
        return;
      }

      const option = options.find((opt) => opt.value === value);
      items.push({
        key: `${group.key}.${key}`,
        groupKey: group.key,
        filterKey: key,
        label,
        value: option ? option.label : value,
      });
    });
  });

  if (filters.vtuberName?.vtuberName) {
    items.push({
      key: "name",
      groupKey: "vtuberName",
      filterKey: "vtuberName",
      label: "VTuber名",
      value: filters.vtuberName.vtuberName,
    });
  }

  return items;
}
